export default "__VITE_ASSET__CHgBRn8s__"